import React from "react";

const escape = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

/* Picks the figure out of a line of copy and tints it.
 *
 * The colour means exactly one thing on this page — a number — so the marks are
 * declared in content.js rather than sniffed out of the text. That keeps
 * "12-MP" tinted while leaving, say, a stray digit in prose alone. */
export default function Figures({ text, mark }) {
  const marks = (Array.isArray(mark) ? mark : [mark]).filter(Boolean);
  if (!marks.length) return text;

  const pattern = new RegExp(`(${marks.map(escape).join("|")})`, "g");

  return text.split(pattern).map((part, i) =>
    marks.includes(part) ? (
      <span key={i} className="figure">
        {part}
      </span>
    ) : (
      <React.Fragment key={i}>{part}</React.Fragment>
    )
  );
}
